/* Black Friday landing page — shared countdown + copy-code.
   Loaded by the hs-bf-* sections that show a countdown or a code.
   Markup:
     [data-hs-bf-countdown][data-end="ISO date"] with [data-hs-bf-d|h|m|s] inside
     [data-hs-bf-countdown-inline][data-end="ISO date"]  → "02d 14h 22m 09s"
     button[data-hs-bf-copy="CODE"]
   One interval re-queries the DOM each tick, so sections re-rendered
   in the theme editor keep working without re-init. */
(function () {
  if (window.HsBfCommon) return;
  window.HsBfCommon = true;

  var pad = function (n) { return String(Math.max(0, n)).padStart(2, '0'); };

  function parts(endAttr) {
    var end = Date.parse(endAttr || '');
    var left = isNaN(end) ? 0 : Math.max(0, Math.floor((end - Date.now()) / 1000));
    return {
      d: Math.floor(left / 86400),
      h: Math.floor((left % 86400) / 3600),
      m: Math.floor((left % 3600) / 60),
      s: left % 60
    };
  }

  function tick() {
    document.querySelectorAll('[data-hs-bf-countdown]').forEach(function (box) {
      var p = parts(box.getAttribute('data-end'));
      ['d', 'h', 'm', 's'].forEach(function (k) {
        var el = box.querySelector('[data-hs-bf-' + k + ']');
        if (el) el.textContent = pad(p[k]);
      });
    });
    document.querySelectorAll('[data-hs-bf-countdown-inline]').forEach(function (el) {
      var p = parts(el.getAttribute('data-end'));
      el.textContent = pad(p.d) + 'd ' + pad(p.h) + 'h ' + pad(p.m) + 'm ' + pad(p.s) + 's';
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-hs-bf-copy]');
    if (!btn) return;
    var code = btn.getAttribute('data-hs-bf-copy');
    var label = btn.getAttribute('data-label') || btn.textContent;
    btn.setAttribute('data-label', label);
    if (navigator.clipboard) navigator.clipboard.writeText(code).catch(function () {});
    btn.textContent = btn.getAttribute('data-copied') || 'Copied';
    setTimeout(function () { btn.textContent = label; }, 1600);
  });

  tick();
  setInterval(tick, 1000);
})();
